<style lang="scss" scoped>
.visit-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 10px;
  width: 100%;
}
.visit-item {
  display: flex;
  flex-direction: column;
  margin: 10px;
  cursor: pointer;
}
.visit-name {
  margin: 5px;
  font-weight: bold;
  text-align: center;
}
.visit-label {
  margin: 5px;
  text-align: center;
}
.obfuscated-text {
  color: transparent;
  text-shadow: 0 0 6px black;
}
.avatar {
  display: block;
  position: relative;
  width: 100%;
  background-size: cover;

  &::before {
    content: "";
    display: block;
    padding-top: 100%;
  }
}
.hide-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 85%;
}
</style>

<template>
  <div class="visit-container">
    <modal
      name="modal-search-box"
      width="80%"
      height="auto"
      style="overflow-y: scroll"
    >
      <user-search-box class="pl-3 pr-3"></user-search-box>
    </modal>
    <div class="col-12">
      <div class="row">
        <Button
          class="btn bg-primary text-white btn-lg btn-block rounded mb-3 ml-3 d-xl-none"
          type="button"
          @click="$modal.show(`modal-search-box`)"
        >
          <i class="fa fa-search"></i> <i class="fa fa-user pr-3"></i>
          Mitgliedersuche
        </Button>
      </div>
    </div>
    <div class="col-12 text-center">
      <h5>
        Deine Profilbesuche aus den letzten {{ profileVisitDisplayDays }} Tagen
      </h5>
    </div>
    <div class="col-12">
      <div class="row">
        <div
          class="p-0 col-12 col-sm-6 col-md-4"
          v-for="(item, index) in visits"
          :id="'visit-' + item.id"
          :key="index"
        >
          <div @click="handleClick(item)" class="visit-item shadow">
            <div
              class="avatar"
              :style="{
                'background-image':
                  'url(' +
                  item.visitor_image_url +
                  '?width=200&height=200&count=' +
                  counter +
                  ')'
              }"
            ></div>
            <div class="visit-name">
              <span
                class="hide-overflow"
                :class="{ 'obfuscated-text': !item.visitor_profile_url }"
                >{{ item.visitor_profile_name }}</span
              >
              <i
                class="pl-1 fas fa-circle icon"
                :class="{
                  'text-success': item.visitor_online,
                  'text-danger': !item.visitor_online
                }"
              ></i>
            </div>
            <div class="visit-label">{{ item.formatted_date }}</div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="loading"
      class="d-flex justify-content-center align-items-center"
    >
      <i class="fas fa-spinner fa-pulse fa-2x"></i>
    </div>
    <div v-if="!hasResults && !loading">
      Dein Profil wurde noch nicht besucht.
    </div>
  </div>
</template>

<script>
import moment from "moment";
import swal from "sweetalert2";

export default {
  data() {
    return {
      loading: true,
      buying: false,
      selected: null,
      requestedResults: 0,
      bottom: false,
      take: 0,
      counter: 0
    };
  },
  methods: {
    handleClick(item) {
      if (item.visitor_profile_url) {
        window.location.href = item.visitor_profile_url;
      } else {
        this.selected = item.id;
        swal
          .fire({
            title: "Profilbesucher aufdecken",
            text:
              "Jetzt für " +
              this.profileVisitPrice +
              " " +
              this.currency +
              " erfahren, wer Ihr Profil besucht hat.",
            showCancelButton: true,
            confirmButtonColor: "#28a745",
            cancelButtonColor: "#d33",
            confirmButtonText:
              "Für " +
              this.profileVisitPrice +
              " " +
              this.currency +
              " freischalten",
            cancelButtonText: "Nein Danke"
          })
          .then(result => {
            if (result.value) {
              this.buy();
            }
          });
      }
    },
    buy() {
      this.$store.dispatch("profileVisit/buy", this.selected).then(() => {
        this.counter++;
      });
    },
    bottomVisible() {
      const scrollY = window.scrollY;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const bottomOfPage = visible + scrollY >= pageHeight - 100;
      return bottomOfPage || pageHeight < visible;
    },
    updateResults(take) {
      let filter = {};
      filter.take = take || 9;
      this.requestedResults = this.visits.length + filter.take;
      filter.skip = this.visits.length;
      this.loading = true;
      moment.locale("de");
      this.$store
        .dispatch("profileVisit/read", { filter })
        .then(() => {
          if (this.requestedResults > this.visits.length) this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    currency() {
      return Laravel.lang.currency;
    },
    profileVisitPrice() {
      return Laravel.settings.profileVisitPrice;
    },
    profileVisitDisplayDays() {
      return Laravel.settings.profileVisitDisplayDays;
    },
    visits() {
      this.$store.getters["profileVisit/profileVisits"].forEach(elem => {
        elem.formatted_date =
          moment(elem.visited_at) < moment().subtract(5, "minutes")
            ? moment(elem.visited_at).fromNow()
            : "vor kurzem";
      });
      return this.$store.getters["profileVisit/profileVisits"];
    },
    hasResults() {
      return this.visits !== null && this.visits.length > 0;
    }
  },
  watch: {
    bottom(bottom) {
      if (bottom && !this.loading) this.updateResults();
    }
  },
  mounted() {
    window.addEventListener("scroll", () => {
      this.bottom = this.bottomVisible();
    });
    this.updateResults();
  }
};
</script>
